import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ScoreDiv from './ScoreDiv';
import ScoreImgDiv from './ScoreImgDiv';

import greenArrow from '../../assets/img/arrow_udown_green.svg';

export default class ScoreRow extends Component {
  static propTypes = {
    text: PropTypes.string,
    score: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    to: PropTypes.string,
    className: PropTypes.string,
  };
  static defaultProps = {
    showArrow: false,
    showMedal: false,
    score: 0,
    to: '',
    className: '',
  };
  constructor (props) {
    super(props);
    this.state = {
      text: this.props.text,
      score: this.props.score,
      showMedal: this.props.showMedal,
      showArrow: this.props.showArrow,
      to: this.props.to.length ? this.props.to : false,
    };
  }

  componentWillReceiveProps(state) {
    this.setState({
      ...this.state,
      ...state,
    });
  }

  render() {
    return (
      <div className={`score-row ${this.props.className}`}>
        {this.state.to ? (
          <Link className={`score-row-inner${(this.state.showArrow ? ' has-arrow' : '')}`} to={this.state.to} href={this.state.to}>
            <p>
              {this.state.text}
              {this.state.showArrow ?
                <span className={'arrow-button'}>
                  <img alt={'greenArrow'} src={greenArrow} />
                </span> : ''
              }
            </p>
          </Link>
        ) : (
          <div className={`score-row-inner${(this.state.showArrow ? ' has-arrow' : '')}`}>
            <p>
              {this.state.text}
              {this.state.showArrow ?
                <span className={'arrow-button'}>
                  <img alt={'greenArrow'} src={greenArrow} />
                </span> : ''
              }
            </p>
          </div>
        )}

        {!this.props.imgs ? (
          <ScoreDiv
            text={String(this.state.score)}
            imgs={this.props.imgs}
            showMedal={this.state.showMedal}
          />
        ) : null}

        {this.props.imgs ? (
          <ScoreImgDiv
            imgs={this.props.imgs}
          />
        ) : null}

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/ScoreRow.js